const BindControlsValues = {
    BindMobile: "",
    BindEmailID: "",
    IsMobileVerification: { display: 'none' },
    IsEmailVerification: { display: 'none' },
    OTPFor: 0,
    ExamName: "",
    Desc: ""
}
export default BindControlsValues;